import { useState } from 'react';
import type ICardCharge from '../../../../models/tap-and-go/card-charge.model';
import type ICard from '../../../../models/tap-and-go/card.model';
import Currency from '../../../Shared/Currency';
import TapAndGoChargeReceipt from '../TapAndGoChargeReceipt';
import { TranslationService } from '../../../../services/translation.service';
import './style.scss';

function TapAndGoChargesTable({ id, card, charges }: { id: string; card: ICard; charges: ICardCharge[] }) {
  const [showReceiptForCharge, setShowReceiptForCharge] = useState<ICardCharge | undefined>(undefined);

  return (
    <div id={id}>
      <table className="table tap-and-go-charges-table table--last-row-no-border">
        <thead>
          <tr>
            <th scope="col">{TranslationService.get('tapandgoreceiptspage.date')}</th>
            <th scope="col">{TranslationService.get('tapandgoreceiptspage.sum')}</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {charges.map((charge, i) => (
            <tr key={i}>
              <td>
                <time dateTime={charge.createdDateTime.toFormat('D')}>
                  <span className="fw-bold">{charge.createdDateTime.toFormat('D')}</span>
                </time>
              </td>
              <td>
                <Currency amount={charge.amountInOre * 0.01} />
              </td>
              <td className="text-end">
                <button type="button" className="btn--as-link" onClick={() => setShowReceiptForCharge(charge)}>
                  {TranslationService.get('tapandgoreceiptspage.showreceipt')}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {showReceiptForCharge && <TapAndGoChargeReceipt card={card} charge={showReceiptForCharge} onClose={() => setShowReceiptForCharge(undefined)} />}
    </div>
  );
}

export default TapAndGoChargesTable;
